import React from 'react'

const ChevronUpTransparent = () => (
  <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg">
    <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z" />
  </svg>
)

export default ChevronUpTransparent
